import styled from "styled-components"

const ColouredBg = styled.div`
    background-color: ${props => props.theme.colors.purple};
    position: relative;
    z-index: 1;
`

export default ColouredBg